<i18n>
{
	"en": {
		"failedToFetch": "Failed to search for orders"
	},
	"no": {
		"failedToFetch": "Kunne ikke søke etter ordre"
	}
}
</i18n>

<template>
	<t-horizontal-panel
		:showRightPanel="true"
		style="box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.2);"
	>
		<OrderSearchFilters
			ref="orderSearchFilters"
			slot="left"
			:filtersVisible="filtersVisible"

			@loadSavedSearch="$emit('loadSavedSearch',$event)"
			@saveSearch="$emit('saveSearch')"
			@toggleFilters="toggleFilters(!filtersVisible)"
		/>
		<OrderSearchListGrid
			:filtersVisible="filtersVisible"

			:availableWidth="containerWidth - orderSearchFiltersWidth"

			@toggleFilters="toggleFilters(!filtersVisible)"
			@showAddToTrip="$emit('showAddToTrip', $event)"
			@showAddToTransporter="$emit('showAddToTransporter', $event)"
			@search="performFetchOrders"
		/>
	</t-horizontal-panel>
</template>

<script>
import { mapDynamicActions } from '@/core/mapDynamic';
import OrderSearchFilters from './OrderSearchFilters.vue';
import OrderSearchListGrid from './OrderSearchListGrid';

export default {
	name: 'OrderSearchListMain',
	components: { OrderSearchFilters, OrderSearchListGrid },
	props: {
		containerWidth: Number,
	},
	inject: ['namespace'],
	data() {
		return {
			detailsVisible: false,
			filtersVisible: true,
			orderSearchFiltersResizeObserver: null,
			orderSearchFiltersWidth: null,
		};
	},
	computed: {
		computedStoreNamespace() {
			return `loadPlanning/${this.namespace.id}`;
		},
		localStorageId() {
			return `loadPlanningList/${this.namespace.id}`;
		},
	},
	watch: {
		'namespace.id': {
			handler() {
				this.setDefaultFilterVisibility();
			},
			immediate: true
		}
	},
	mounted() {
		document.addEventListener('keyup', this.onKey, { passive: true, capture: true });

		this.$nextTick()
			.then( () => {
				this.setupOrderSearchFiltersResizeObserver();
			});
	},
	beforeDestroy() {
		document.removeEventListener('keyup', this.onKey, { capture: true });

		if (this.orderSearchFiltersResizeObserver)
			this.orderSearchFiltersResizeObserver.disconnect();
	},
	methods: {
		...mapDynamicActions('computedStoreNamespace',['fetchOrders']),

		setupOrderSearchFiltersResizeObserver() {

			let element = this.$refs.orderSearchFilters.$el;

			this.orderSearchFiltersWidth = element.getBoundingClientRect().width;

			this.orderSearchFiltersResizeObserver = new ResizeObserver(() => {

				this.orderSearchFiltersWidth = element.getBoundingClientRect().width;
			});

			this.orderSearchFiltersResizeObserver.observe(element);
		},

		toggleFilters(value = true) {
			localStorage.setItem(`${this.localStorageId}/orderFilterVisible`, value);
			this.filtersVisible = value;
		},
		setDefaultFilterVisibility() {
			let orderFilterOpen = localStorage.getItem(`${this.localStorageId}/orderFilterVisible`);
			if (orderFilterOpen === null || orderFilterOpen === 'true')
				this.toggleFilters(true);
			else
				this.toggleFilters(false);
		},
		async performFetchOrders() {
			try {
				await this.fetchOrders();
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('failedToFetch')
				});
			}
		},
	}
};
</script>

<style lang="scss" scoped>

.slide-right-enter, .slide-right-leave-to {
	transform: translateX(-100%);
}
</style>
